<template>
    <div id="lMyMTraining">
        <div class="lMyMTrainingFirst">
            <div class="lMyMTrainingFirstTitle">我的课程</div>
            <div class="lMyMTrainingFirstSelect">
                <span>年份</span>
                <Select class="yearChange" v-model="queryInfo.yearNum" @on-change="yearChange">
                    <Option v-for="(item,i) in cityList" :value="item.value" :key="i">{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div>
            <Table :columns="columns1" :data="data1">
                <template slot="signUp">
                    <div>点击追加学分</div>
                </template>
                <template slot="question" slot-scope="{row}">
                    <span v-if="row.voteStatus !== 1 && row.voteId !== null && row.projectType !== 2">未填</span>
                    <span v-else-if="row.projectType === 2">/</span>
                    <span v-else>已填</span>
                </template>

                <template slot-scope="{row,index}" slot="action">
                    <div v-if="row.learnStatus !== 5 && row.learnStatus !== 10">
                        <!-- {{row.title}}{{index}} -->
                        <!-- <Button  type="primary" size="small" ghost @click="toLive(row)">学习</Button> -->
                        <div class="study" v-if="userTye!=1 && row.learnStatus !== 4" @click="toLive(row)">学习</div>
                        <div class="fillin study" v-if="row.voteStatus !== 1 && row.voteId !== null && row.projectType !== 2" @click="handleToGo(row)">填问卷</div>
                    </div>
                </template> 
            </Table>
            <div class="ivu-mt ivu-text-center">
                <Page :total="dataCount" :page-size="pageSize" :current.sync="current" show-elevator show-total class="paging" @on-change="changepage" @on-page-size-change="changepagesize"></Page>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getAllProject,
        queryUserProject
    } from "../../../network/LPersonal";

    import Cookies from "js-cookie";

    export default {
        data() {
            return {
                cityList: [],
                queryInfo: {
                    yearNum: "",
                    curPage: 1,
                    maxPage: 10,
                },

                historyData: [],
                current: 1,
                boQuery: false,
                ajaxHistoryData: [],
                // 初始化信息总条数
                dataCount: 0,
                // 每页显示多少条
                pageSize: 10,
                //总共多少页
                totalTs: 1,

                columns1: [{
                        title: "订单号",
                        key: "orderNo",
                        minWidth: 100,
                        align:"center"
                    },
                    {
                        title: "项目名称",
                        key: "projectName",
                        minWidth: 130,
                        align:"center"
                    },
                    {
                        title: "报名时间",
                        key: "orderTime",
                        sortable: true,
                        minWidth: 105,
                        align:"center"
                    },
                    {
                        title: "学时",
                        key: "creditHour",
                        width: 80
                    },
                    // {
                    //     title: "修改报名",
                    //     key: "age",
                    //     slot: "signUp",
                    // },
                    {
                        title: "学习状态",
                        key: "learnStatus",
                        slot: "learnStatus",
                        width: 100,
                        render(h, params) {
                            if(params.row.status==2){
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "已退款"
                                );
                            }else {
                                if (params.row.learnStatus == 1) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "学习中"
                                );
                            } else if (params.row.learnStatus == 3) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "学习中"
                                );
                            } else if (params.row.learnStatus == 4) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "完成培训"
                                );
                            } else if (params.row.learnStatus == 5) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "未通过"
                                );
                            } else if (params.row.learnStatus == 6) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "重新学习"
                                );
                            } else if (params.row.learnStatus == 7) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "重新学习通过"
                                );
                            } else if (params.row.learnStatus == 8) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "重新学习未通过"
                                );
                            } else if (params.row.learnStatus == 9) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "请写论文"
                                )
                            } else if (params.row.learnStatus == 10) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#000",
                                        },
                                    },
                                    "补修通过"
                                );
                            }
                            }
                        },
                    },
                    {
                        title: "问卷状态",
                        key: "creditHour",
                        slot: 'question',
                        width:97
                    },
                    {
                        title: "操作",
                        key: "loading",
                        slot: "action",
                        width:107
                    },
                ],
                data1: [],
                userTye: "", //账户类型  0 个人  1企业
            };
        },
        created() {
            this.getData();
            this.$emit("editPage", "我的课程", "我的课程");
            this.userTye = this.Get("type");
            this.time()
        },
        activated() {
            this.getData();
            this.$emit("editPage", "我的课程", "我的课程");
            this.time()
        },
        methods: {
            handleToGo(row) {
                this.$router.push({
                    path: "/questionnaire",
                    query: { id: row.voteId,pid:row.projectId },
                });
            },
            //分页器
            handleListApproveHistory() {
                // 保存取到的所有数据
                this.ajaxHistoryData = this.data1;
                // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                if (this.data1.length < this.pageSize) {
                    this.historyData = this.ajaxHistoryData;
                } else {
                    this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
                }
            },
            changepage(index) {
                this.current = index;
                var _start = (index - 1) * this.pageSize;
                var _end = index * this.pageSize;
                this.historyData = this.ajaxHistoryData.slice(_start, _end);
                this.getData();
            },
            changepagesize(pageSize) {
                this.pageSize = pageSize;
                this.getData();
                this.handleListApproveHistory()
            },

            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            time() {
                var myDate = new Date();
                var year = myDate.getFullYear(); //获取当前年
                this.yearsModel = year;
                this.initSelectYear(year);
            },
            initSelectYear(year) {
                this.yearsArr = [];
                this.cityList.push({
                    label: '全部',
                    value: -1
                })
                for (let i = 0; i < 30; i++) {
                    this.cityList.push({
                        value: year - i,
                        label: year - i + "年"
                    });
                }
            },
            getData() {
                let year = this.queryInfo.yearNum;
                if(this.queryInfo.yearNum == -1){
                    year = null;
                }
                queryUserProject({
                    curPage: this.current,
                    maxPage: this.pageSize,
                    yearNum: year
                }).then((res) => {
                    console.log(res);
                    this.data1 = res.data.data.data;
                    this.handleListApproveHistory();
                    this.dataCount = res.data.data.total;
                });
            },
            yearChange(v) {
                console.log(v);
                this.queryInfo.yearNum = v;
                this.current = 1;
                this.getData();
            },
            toLive(row) {
                console.log(row, "介绍");
                localStorage.removeItem("projectData");
                localStorage.setItem("projectData", JSON.stringify(row));
                this.$router.push({path:"/courseList"});
            },
        },
    };
</script>

<style>
    @import url("../../../assets/css/liucss/myTraining.css");
    .ivu-text-center{
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
</style>
<style scoped>
.study{
    width: 87px;
    height: 33px;
    border: 1px solid #3562E8;
    border-radius: 4px;
    line-height: 33px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3562E8;
    margin: 14px 0;
    cursor: pointer;
}
.fillin{
}
</style>